import { useMutation, useQueryClient } from "@tanstack/react-query";
import postsMediaAPI from "../../api/posts-media/api";

export function useUpdatePostMedia() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postsMediaAPI.updatePostMedia,
    onSuccess: (data, variables) => {
      // Invalidate and refetch posts media list
      queryClient.invalidateQueries({ queryKey: ["posts-media"] });
    },
    onError: (error) => {
      console.error("Update post media failed:", error);
    },
  });
}
